let url = "164.90.186.99";
let port = "80"
 //
 // let url = "localhost";
 // let port = "3001"
const headerAuthorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6InN5c3RlbSBhZG1pbiIsImlhdCI6MTUxNjIzOTAyMn0.gES6TGqAa9mvKdW9PcgO7GTdI7ANCqPccDyQmhe31ek'

module.exports = {
    url,
    port,
    headerAuthorization
};
